import { liabilityPolicyStatusOptionsPayerTypes } from "./systemData"

export const liabilityFunctions = {
    isLiabilityValid: (liabilities, extraField = null) => {
        let liability = liabilities.find(item => item.is_primary_insurance)
        if (liability && liability.active && liability.liability_status == 1 && liability.claim_number) {
    
            if (extraField) {
                if ( extraField == 'policy_limit_patient' || extraField == 'policy_limit_accident') {
                    return liabilityFunctions.liabilityHasPolicyLimit(liability)
                }
            }
            return liability
        }
    
        return false
    },
    liabilityHasPolicyLimit: (liability) => {
        if (liability && (liability.policy_limit_patient &&  liability.policy_limit_accident)) {
            return liability
        }
    
        return false
    },
    liabilityVerification: (liabilities) => {
        const tabState = {
            dot: false,
            dot_color: null,
            background: null,
            color: null,
            message: null
        };

        // Determine primaryInsurance efficiently
        let primaryInsurance = null;
        if (Array.isArray(liabilities)) {
            primaryInsurance = liabilities.find(item => item.is_primary_insurance) || null;
        } else if (liabilities) {
            primaryInsurance = liabilities;
        }

        if (primaryInsurance) {
            const arr = [];

            // old logic for various fileds, replaced by status colors
            // // Liability status logic, prioritizing by severity
            // if (primaryInsurance.liability_status === 0) {
            //     arr.push('Liability status is Denied');
            //     tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)';
            //     tabState.color = 'var(--red)';
            // } else if (primaryInsurance.verified && primaryInsurance.liability_status === 2) {
            //     arr.push('Liability status is Investigation');
            //     tabState.background = 'var(--orange1)';
            // } else if (primaryInsurance.verified && primaryInsurance.liability_status === 1) {
            //     tabState.background = 'var(--green-verification)';
            //     tabState.color = 'var(--text)';
            // }

            // // Policy is not verified
            // if (!primaryInsurance.verified) {
            //     arr.push('Policy is not verified');
            //     tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
            //     tabState.color = 'var(--dark-yellow)';
            // }

            // START status color logic
            let option = liabilityPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryInsurance.policy_status)

            if (option) {
                tabState.classColor = 'bk_' + option.color?.split(' ').join('_')
            }

            if (primaryInsurance.liability_status === 0) {
                tabState.classColor = 'bk_Red'
            }

            // Liability status is not Denied
            if (primaryInsurance.liability_status != 0) {
                
                // Dot warnings/errors
                // Prioritize required missing fields, but don't override orange if it was set for litigating
                if (!primaryInsurance.claim_number && !primaryInsurance.policy_number) {
                    arr.push('Policy Number was not provided');
                    tabState.dot = true;
                    tabState.dot_color = 'var(--red)';
                }
                if (primaryInsurance.verified && !primaryInsurance.claim_number) {
                    arr.push('Claim Number was not provided');
                    tabState.dot = true;
                    tabState.dot_color = 'var(--red)';
                }
                if (primaryInsurance.litigating_responsibility) {
                    arr.push('Policy has Litigating Responsability');
                    tabState.dot = true;
                    tabState.dot_color = 'var(--orange1)';
                }
                if (primaryInsurance.verified && !(primaryInsurance.policy_limit_patient )) {
                    arr.push('Policy Limit Patient was not provided');
                    tabState.dot = true;
                    tabState.dot_color = 'var(--red)';
                }
                if (primaryInsurance.verified && !(primaryInsurance.policy_limit_accident)) {
                    arr.push('Policy Limit Accident was not provided');
                    tabState.dot = true;
                    tabState.dot_color = 'var(--red)';
                }
            }

            // END status color logic

            if (arr.length > 0) {
                tabState.message = `<div>${arr.map(item => `<div>${item}</div>`).join('')}</div>`;
            }
        }

        return tabState;
    },
    liabilityIsADeviation: (activeCase) => {
        // has multiple carriers or more than one rider (has related patients)
        if (activeCase && activeCase.liabilities && activeCase.liabilities.length > 1) {
            if (activeCase.liabilities.every(item => item.active)) {
                return true
            }
        }
        if (activeCase && activeCase.related_patients && activeCase.related_patients.length > 0) {
            return true
        }
    
        return false
    }
}